import {Module} from 'vuex';
import {actions} from './actions';
import {mutations} from './mutations';
import {AdminusStore} from '@/store/types';
import {BackendData} from './types';

export const state: BackendData = {
    allData: [],
};
const namespaced: boolean = true;

export const deployData: Module<BackendData, AdminusStore> = {
    namespaced,
    actions,
    mutations,
    state,
};
